export default {
  mediaQueries: {
    small: '(max-width: 760px)',
    medium: '(min-width: 761px) and (max-width: 1024px)',
    large: '(min-width: 1025px) and (max-width: 1440px)',
    wide: '(min-width: 1441px)'
  }
};
